import { useRef, useCallback, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { scrollIntoViewInViewportCenter } from '@wix/da-shared-react/pkg/utils/scrollIntoViewWithHeader';

export function useScrollToField() {
  const isMobile = useContext(MobileContext);
  const scrollableRef = useRef<HTMLElement>(undefined);
  const scrollToField = useCallback(
    (fieldWrapperEl: HTMLDivElement) => {
      const scrollableEl = scrollableRef.current;
      if (scrollableEl && fieldWrapperEl) {
        scrollIntoViewInViewportCenter(
          fieldWrapperEl,
          isMobile,
          scrollableEl,
          true
        );
      }
    },
    [isMobile]
  );

  return {
    scrollableRef,
    scrollToField,
  };
}
